export default class Message {
    constructor(type, message, transition = true, onDict = true, time = 5) {
        this.type = type;
        this.message = message;
        this.time = time;
        this.transition = transition;
        this.onDict = onDict;
    }
}
